import moment from "moment";
const ua = typeof window === 'object' ? window.navigator.userAgent : '';
let _isIOS = -1
let _isAndroid = -1
    //矫治器
export function retainerFilter(status) {
    const statusMap = {
        1: '上颌',
        2: '下颌',
        3: '全颌',
        4: '附件模板矫治器上颌',
        5: '附件模板矫治器下颌',
        6: '附件模板矫治器全颌',
        7: '酸蚀附件模板矫治器上颌',
        8: '酸蚀附件模板矫治器下颌',
        9: '酸蚀附件模板矫治器全颌',
    }
    return statusMap[status]
}
export function pathFilter(type, url) {
    let uploadDomain = localStorage.getItem("UPLOAD_URI") || `${process.env.UPLOAD_DOMAIN}`;
    let feedbackUrl = localStorage.getItem("UPLOAD_FEEDBACK_URI") || `${process.env.UPLOAD_DOMAIN_FEEDBACK}`
    // 图片地址
    const statusMap = {
        s: `${uploadDomain}/S?appID=3&path=`,
        b: `${uploadDomain}/B?appID=3&path=`,
        f: `${uploadDomain}/F?appID=3&path=`,
        v: `${uploadDomain}/V?appID=3&path=`,
        oss: `${feedbackUrl}/cdc/oss/imagePath?pathKey=`
    };
    if (url) {
        if (type === 's') {
            return statusMap[type] + url + '&h=200'
        } else {
            return statusMap[type] + url
        }
    } else {
        return ''
    }
}
export function momentTime(time, cFormat) {
    if (arguments.length === 0 || !time) {
        return null;
    }
    if (moment(time).isBefore("2000-01-01")) {
        return null;
    }
    const formatter = cFormat || "YYYY-MM-DD HH:mm:ss";
    if (cFormat === 'chineseHasSecond') {
        const engFormat = moment(time).format("YYYY-MM-DD HH:mm:ss");
        const format1 = engFormat.split(" ")[0]
        const format2 = engFormat.split(" ")[1]
        const year = format1.split('-')[0]
        const month = format1.split('-')[1]
        const day = format1.split('-')[2]
        return `${year}年${month}月${day}日 ${format2}`
    }
    return moment(time).format(formatter);
}
//病例状态
export function SubType(status) {
    const statusMap = {
        1: "病例资料待提交",
        2: "病例资料已提交",
        3: "模型质检",
        4: "病例动画待确认",
        5: "提出修改意见",
        6: "病例动画已确认",
        7: "首阶段已发货",
        8: "加工后续待确认",
        9: "加工后续已确认",
        10: "阶段已发货",
        11: "结束治疗",
        12: "后期保持器已发货"
    };
    return statusMap[status];
}
//阶段类型
export function processType(status) {
    const statusMap = {
        1: "新增患者",
        2: "精细调整",
        3: "结束治疗",
        4: "病例重启",
        5: "病例直通车",
        6: "复诊资料",
        99: '客服上传'
    };
    return statusMap[status];
}
//病例资料&设计通用状态
export function designStatusType(status) {
    const statusMap = {
        0: "未确认",
        1: "已确认",
        2: "放弃"
    };
    return statusMap[status];
}
//模型
export function modelDataTypeStatus(key) {
    let statusMap = {
        1: "本地文件",
        2: "3Shape/西诺德口扫数据",
        3: "邮件发送",
        4: "正雅口扫数据",
        5: "设计数据",
        6: "硅橡胶印模",
        7: "硅橡胶印模+咬合记录",
        8: "石膏模型"
    };
    return statusMap[key];
}
//口扫类型
export function scanTypeStatus(key) {
    let statusMap = {
        1: "3Shape",
        2: "西诺德"
    };
    return statusMap[key];
}
//反馈类型
export function feedbackType(status) {
    const statusMap = {
        1: "咨询",
        2: "建议",
        3: "投诉"
    };
    return statusMap[status];
}
//反馈状态
export function feedbackStatus(status) {
    const statusMap = {
        1: "已提交",
        2: "已回复",
        3: "已解决"
    };
    return statusMap[status];
}
//IOS
export function isIOS() {
    if (_isIOS === -1) {
        _isIOS = /iPhone|iPod|iPad/i.test(ua) ? 1 : 0;
    }
    return _isIOS === 1;
}
//android
export function isAndroid() {
    if (_isAndroid === -1) {
        _isAndroid = /Android/i.test(ua) ? 1 : 0;
    }
    return _isAndroid === 1;
}

export function formatMoney(str) {
    if (str == null || str === '') {
        return ''
    }
    return str.replace(/(\d)(?=(\d{3})+$)/g,'$1,')
}

export function lingualFixModeFilter(status) {
    const statusMap = {
        0: "未选择",
        1: "去除舌侧丝",
        2: "保留舌侧丝"
    }
    return statusMap[status]
}


// WEBPACK FOOTER //
// ./src/filters/index.js